export default __webpack_public_path__ + "static/top_background-8ca89baccae64cf9e23c95d376d69036.png";